import React from 'react';
import PropTypes from 'prop-types';

import {Box, Divider, Stack, Typography, Skeleton, Link} from 'views/components';

import {HoverToolBox, Translate} from 'views/module';

import backend from 'utils/backend';

const ClientView = (props) => {
  const [clientData, setClientData] = React.useState(null);

  const [toolbarVisible, setToolbarVisible] = React.useState(false);
  const [mouseOver, setMouseOver] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const client = props.client;
  const removeClient = props.removeClient;

  React.useEffect(() => {
    setToolbarVisible(mouseOver);
  }, [mouseOver]);

  // Load client data
  React.useEffect(() => {
    backend.client.getClient(client.clientRn, true)
        .then((e) => {
          setClientData(e);
        })
        .catch(() => {
          console.error('Failed to load client data');
        });
  }, [client]);

  return (
    <Box>
      <Divider/>
      <Box
        onMouseOver={(e) => setMouseOver(true) & setAnchorEl(e.currentTarget)}
        onMouseLeave={(e) => setMouseOver(false)}
        sx={{
          backgroundColor: toolbarVisible ? 'background.highlighted': 'inherit',
          p: 2,
        }}
      >
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='caregiver.CaregiverDetail.ClientConnections.Client.ClientName'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {clientData ? (
                <Link href={`/client/${clientData.clientRn}`}>
                  {clientData.clientDetail.clientName}
                </Link>
              ) : (
                <Skeleton sx={{fontSize: '14px', width: '100px'}} />
              )}
          </Typography>
        </Stack>
        <HoverToolBox
          toolBar={toolbarVisible}
          anchorEl={anchorEl}
          onClickDelete={() => removeClient(client.clientRn)}
          hideTool={{
            emoji: true,
            copy: true,
            edit: true,
            delete: false,
          }}
        />
      </Box>
    </Box>
  );
};

ClientView.propTypes = {
  client: PropTypes.object.isRequired,
  removeClient: PropTypes.func.isRequired,
};

export default React.memo(ClientView);
